<script setup lang="ts">
/**
 * PageTitle — 모든 FO 내용 페이지의 상단 타이틀 밴드(eyebrow + h1 + 설명). 타이틀 밴드의 단일 컴포넌트.
 *
 * 결제·장바구니·법률·마이페이지가 각자 복붙·분기하던 `.page-title` 밴드를 하나로 통합했다
 * (구 MyPageHeader 흡수 — 마이페이지는 eyebrow="마이페이지" 를 명시해 사용). 하단 border-b 로 본문과 구분.
 *
 * ⚠️ 상단 패딩 없음(pt-*) — 페이지 상단 여백은 PageShell 이 단일 책임(pt-page-top).
 *    밴드에 pt 를 두면 셸 패딩과 이중으로 쌓여 상단이 과하게 벌어진다.
 *
 * - eyebrow : 상단 골드 라벨(선택). 없으면 렌더 생략. (마이페이지=정확히 "마이페이지" 전달)
 * - title   : 페이지 제목(h1, serif).
 * - description : 제목 아래 설명(선택). 없으면 렌더 생략.
 * - 기본 슬롯 : 제목 우측 부가 요소(선택, 예: "(주문 N건)").
 */
interface Props {
  /** 상단 골드 eyebrow 라벨(선택). */
  eyebrow?: string;
  /** 페이지 제목(h1). */
  title: string;
  /** 제목 아래 설명 문구(선택). */
  description?: string;
}

defineProps<Props>();
</script>

<template>
  <header class="mb-8 border-b border-line pb-6">
    <p v-if="eyebrow" class="text-xs font-extrabold uppercase tracking-[0.12em] text-accent-deep">
      {{ eyebrow }}
    </p>
    <h1
      class="font-serif text-[22px] font-extrabold tracking-[-0.02em] text-brand md:text-[27px]"
      :class="eyebrow ? 'mt-2' : ''"
    >
      {{ title }}
      <slot />
    </h1>
    <p v-if="description" class="mt-2 text-sm leading-[1.6] text-body">
      {{ description }}
    </p>
  </header>
</template>
